// miniapp/src/client/components/HomeButton.tsx
import type { JSX } from "react";
import { ROUTE } from "../lib/paths";
import { homeRouteFor, normalizeRole } from "../lib/rbac";
import { api } from "../lib/api";

export default function HomeButton({ className = "" }: { className?: string }): JSX.Element {
  const onClick = async () => {
    try {
      const me = await api.me();
      const role = normalizeRole(me.role);
      const target = homeRouteFor(role);
      ROUTE.go(target);
    } catch {
      ROUTE.go(ROUTE.guest());
    }
  };

  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-xl border border-white/15 bg-white/10 px-3 py-2 text-xs text-white hover:bg-white/15 ${className}`}
    >
      На главную
    </button>
  );
}